export default {
    "items": [
        {
            "text": "Please indicate your general interest/comfort level with any/all of the following common core succession strategies that can be leveraged in building your firm's succession plan:",
            "questionWidth": 12,
            "subItems": [
                {
                    "text": "Incremental Equity Sale",
                    "type": "slider",
                    "name": "succession-incremental-equity-sale",
                    "props": {
                        "labels": [
                            "Least Interested",
                            "undefined",
                            "undefined",
                            "undefined",
                            "undefined",
                            "Most Interested"
                        ]
                    },
                    "subItems": [
                        {
                            "text": "The equity purchase model would involve you selling a non-controlling interest (up to 49%, for example, though typically closer to 30-40% depending on company size and timeline) to your successor(s) today, allowing them to own a percentage of the company, profits, and appreciation in value from now until you retire. This aligns your goals, causing the successor(s) to think like an owner and help grow the firm. These transactions are typically structured so you receive cash for the portion sold today, with the successor(s) paying it back to an industry lender over 10 years using any increase in salary he/she would receive as a new partner as well as using any profits they are now entitled to. This strategy allows you to reduce risk and “cash out” some of the equity/value you have built, while the remaining equity can be purchased and paid for in another lump sum (or incrementally) based on the projected retirement date.",
                            "questionWidth": "12"
                        }
                    ]
                },
                {
                    "text": "Basic Closed Loop Sale",
                    "type": "slider",
                    "name": "succession-basic-closed-loop-sale",
                    "props": {
                        "labels": [
                            "Least Interested",
                            "undefined",
                            "undefined",
                            "undefined",
                            "undefined",
                            "Most Interested"
                        ]
                    },
                    "subItems": [
                        {
                            "text": "The Closed Loop Sale strategy involves you selling small non-controlling interests (typically 5-15%) to your successor(s) today, allowing them to own 5%, for example, of the company, profits, and appreciation from now until the next tranche of ownership is sold. This will provide the successor(s) with the incentive to continue to help drive growth in the firm, since they will be the benefactor of the appreciation. These smaller transactions are company/seller financed on a flexible promissory note that is paid back using their future interest in profits (hence the Closed Loop Sale label). This strategy will often plan out 4 or 5 sale events to get the successor to the targeted ownership position. This strategy allows you to “start slow” and share small amounts of ownership on your terms, without the need for outside financing. As goals/benchmarks are achieved, additional ownership may be sold over time. One of the key goals of a strategy like this is to allow you to groom a successor, gradually transition ownership so the owner/founder can slow down, maintain ultimate flexibility, while the company continues to grow and retain its top talent. The detriment of this strategy is the tax inefficiency, but it offers maximum flexibility.",
                            "questionWidth": 12
                        }
                    ]
                },
                {
                    "text": "Shared Growth Model",
                    "type": "slider",
                    "name": "succession-shared-growth-model",
                    "props": {
                        "labels": [
                            "Least Interested",
                            "undefined",
                            "undefined",
                            "undefined",
                            "undefined",
                            "Most Interested"
                        ]
                    },
                    "subItems": [
                        {
                            "text": "The Shared Growth Model would establish a base value effective today (for example, $1 million “base value”) that you would maintain 100% ownership in (unless you chose to grant some amount of the base value to someone). You would then grant a 10-30% stake in the appreciation of the company’s value beyond the base value. This stake in the future growth is effectively phantom units of ownership that are simply granted and provide some future economic benefit and therefore are not purchased/sold or financed. Upon a triggering event (retirement, death, disability, etc.), the successor will be able to purchase the company for a reduced value based on the appreciation they have accumulated beyond the base value. For example, you might share the appreciated value 80/20 (so the successor would earn 20% equity, for example, in any appreciation beyond the current valuation, you retain 80%). If you retired in 10 years, and the company was worth $3 million, your successor would have collectively earned 20% interest in the $2 million of appreciated value (meaning he/she would get a $400k discount on the buy-out). When you retire, you would sell your combined $2.6 million of value ($1 million base value + 80% of the $2 million appreciated value). This strategy is a simple way for you to accomplish several goals: 1) share equity in the business without requiring a major investment from a successor who may not have the money; 2) eliminate the need for rigid outside financing; 3) avoid the need to share control or an interest in profit distributions; and 4) avoid any current tax issues. However, you still get the benefits of sharing equity — retention of key personnel, getting the employee(s)/successor(s) to start thinking and acting like an owner, and have a stake in the success which should hopefully motivate him or her even more.",
                            "questionWidth": 12
                        }
                    ]
                },
                {
                    "text": "Equity Compensation/Gifting/Grants",
                    "type": "slider",
                    "name": "succession-equity-compensation",
                    "props": {
                        "labels": [
                            "Least Interested",
                            "undefined",
                            "undefined",
                            "undefined",
                            "undefined",
                            "Most Interested"
                        ]
                    },
                    "subItems": [
                        {
                            "text": "Equity compensation is a strategy of outright granting ownership to a successor for no direct receipt of value (received as compensation) and if often used in conjunction with another strategy. This is a common tool for acknowledging a successors existing contribution to the company and/or with family deals where receiving maximum value in cash is not the goal.",
                            "questionWidth": 12
                        }
                    ]
                },
                {
                    "text": "Other",
                    "type": "textarea",
                    "name": "succession-other-description",
                    "props": {}
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/succession-archive/valuation-data/strategies.js